/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MfaEnableVerifyPostRequest
 */
export interface MfaEnableVerifyPostRequest {
    /**
     * 
     * @type {number}
     * @memberof MfaEnableVerifyPostRequest
     */
    code: number;
}

export function MfaEnableVerifyPostRequestFromJSON(json: any): MfaEnableVerifyPostRequest {
    return MfaEnableVerifyPostRequestFromJSONTyped(json, false);
}

export function MfaEnableVerifyPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaEnableVerifyPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function MfaEnableVerifyPostRequestToJSON(value?: MfaEnableVerifyPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

